'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setExpectedAnnualActivity = exports.setActiveCurrency = exports.getActiveCurrency = exports.setDetailsWithoutPassword = exports.setEmailPhone = exports.validateSupportNumber = exports.validatePersonIdv2 = exports.verifyExistingSePlayerWithToken = exports.verifyExistingSePlayer = exports.validatePhone = exports.validateEmail = exports.validateUsername = exports.validateCpr = exports.getOptOutInsByToken = exports.lifetimeStats = exports.paymentStats = exports.changeNickname = exports.changeUsername = exports.tournamentOptIn = exports.bonusOptIn = exports.optOutChoices = exports.optOut = exports.optIn = exports.getOptInOuts = exports.getDisplayPages = exports.removeTag = exports.addTag = exports.getTags = exports.requestActivationCode = exports.activate = exports.resetPassword = exports.requestPasswordReset = exports.updatePlayerTac = exports.signOut = exports.createSSOToken = exports.changePassword = exports.userInfo = exports.update = exports.signUpWithToken = exports.signUpWithCode = exports.signUpV2 = exports.signUp = exports.signInWithCode = exports.signInV2 = exports.signIn = undefined;

var _player = require('tg-core-api/lib/player');

var _player2 = _interopRequireDefault(_player);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var signIn = exports.signIn = function signIn(user) {
  return (0, _action.makeApiCallAction)('SIGNIN', _player2.default.signIn, user);
};
var signInV2 = exports.signInV2 = function signInV2(user) {
  return (0, _action.makeApiCallAction)('SIGNINV2', _player2.default.signInV2, user);
};
var signInWithCode = exports.signInWithCode = function signInWithCode(user) {
  return (0, _action.makeApiCallAction)('SIGNINWITHCODE', _player2.default.signInWithCode, user);
};
var signUp = exports.signUp = function signUp(user) {
  return (0, _action.makeApiCallAction)('SIGNUP', _player2.default.signUp, user);
};
var signUpV2 = exports.signUpV2 = function signUpV2(user) {
  return (0, _action.makeApiCallAction)('SIGNUPV2', _player2.default.signUpV2, user);
};
var signUpWithCode = exports.signUpWithCode = function signUpWithCode(user) {
  return (0, _action.makeApiCallAction)('SIGNUPWITHCODE', _player2.default.signUpWithCode, user);
};
var signUpWithToken = exports.signUpWithToken = function signUpWithToken(user) {
  return (0, _action.makeApiCallAction)('SIGNUPWITHTOKEN', _player2.default.signUpWithToken, user);
};
var update = exports.update = function update(user, playerSessionID) {
  return (0, _action.makeApiCallAction)('PLAYER_UPDATE', _player2.default.update, user, playerSessionID);
};
var userInfo = exports.userInfo = function userInfo(playerSessionID) {
  return (0, _action.makeApiCallAction)('USER_INFO', _player2.default.userInfo, playerSessionID);
};
var changePassword = exports.changePassword = function changePassword(passwords, playerSessionID) {
  return (0, _action.makeApiCallAction)('CHANGE_PASSWORD', _player2.default.changePassword, passwords, playerSessionID);
};
var createSSOToken = exports.createSSOToken = function createSSOToken(playerSessionID, tokenType) {
  return (0, _action.makeApiCallAction)('CREATE_SSO_TOKEN', _player2.default.createSSOToken, playerSessionID, tokenType);
};
var signOut = exports.signOut = function signOut(playerSessionID) {
  return (0, _action.makeApiCallAction)('SIGN_OUT', _player2.default.signOut, playerSessionID);
};
var updatePlayerTac = exports.updatePlayerTac = function updatePlayerTac(tacVersionAccepted, playerSessionID) {
  return (0, _action.makeApiCallAction)('UPDATE_PLAYER_TAC', _player2.default.updatePlayerTac, tacVersionAccepted, playerSessionID);
};
var requestPasswordReset = exports.requestPasswordReset = function requestPasswordReset(usernameOrEmail) {
  return (0, _action.makeApiCallAction)('REQUEST_PASSWORD_RESET', _player2.default.requestPasswordReset, usernameOrEmail);
};
var resetPassword = exports.resetPassword = function resetPassword(resetPasswordModel) {
  return (0, _action.makeApiCallAction)('RESET_PASSWORD', _player2.default.resetPassword, resetPasswordModel);
};
var activate = exports.activate = function activate(usernameOrEmail, code, deviceDetails) {
  return (0, _action.makeApiCallAction)('ACTIVATE', _player2.default.activate, usernameOrEmail, code, deviceDetails);
};
var requestActivationCode = exports.requestActivationCode = function requestActivationCode(usernameOrEmail) {
  return (0, _action.makeApiCallAction)('REQUEST_ACTIVATION_CODE', _player2.default.requestActivationCode, usernameOrEmail);
};
var getTags = exports.getTags = function getTags(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_TAGS', _player2.default.getTags, playerSessionID);
};
var addTag = exports.addTag = function addTag(tag, playerSessionID) {
  return (0, _action.makeApiCallAction)('ADD_TAG', _player2.default.addTag, tag, playerSessionID);
};
var removeTag = exports.removeTag = function removeTag(tag, playerSessionID) {
  return (0, _action.makeApiCallAction)('REMOVE_TAG', _player2.default.removeTag, tag, playerSessionID);
};
var getDisplayPages = exports.getDisplayPages = function getDisplayPages(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_DISPLAY_PAGES', _player2.default.getDisplayPages, playerSessionID);
};
var getOptInOuts = exports.getOptInOuts = function getOptInOuts(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_OPT_IN_OUTS', _player2.default.getOptInOuts, playerSessionID);
};
var optIn = exports.optIn = function optIn(playerSessionID, Type) {
  return (0, _action.makeApiCallAction)('OPT_IN', _player2.default.optIn, playerSessionID, Type);
};
var optOut = exports.optOut = function optOut(playerSessionID, Type) {
  return (0, _action.makeApiCallAction)('OPT_OUT', _player2.default.optOut, playerSessionID, Type);
};
var optOutChoices = exports.optOutChoices = function optOutChoices(optOutToken, optIns) {
  return (0, _action.makeApiCallAction)('OPT_OUT_CHOICES', _player2.default.optOutChoices, optOutToken, optIns);
};
var bonusOptIn = exports.bonusOptIn = function bonusOptIn(playerID, bonusID, playerSessionID) {
  return (0, _action.makeApiCallAction)('BONUS_OPT_IN', _player2.default.bonusOptIn, playerID, bonusID, playerSessionID);
};
var tournamentOptIn = exports.tournamentOptIn = function tournamentOptIn(playerID, tournamentIdentifier) {
  return (0, _action.makeApiCallAction)('TOURNAMENT_OPT_IN', _player2.default.tournamentOptIn, playerID, tournamentIdentifier);
};
var changeUsername = exports.changeUsername = function changeUsername(username, playerSessionID) {
  return (0, _action.makeApiCallAction)('CHANGE_USERNAME', _player2.default.changeUsername, username, playerSessionID);
};

var changeNickname = exports.changeNickname = function changeNickname(nickname, playerSessionID) {
  return (0, _action.makeApiCallAction)('CHANGE_NICKNAME', _player2.default.changeNickname, nickname, playerSessionID);
};

var paymentStats = exports.paymentStats = function paymentStats(playerSessionID) {
  return (0, _action.makeApiCallAction)('PAYMENT_STATS', _player2.default.paymentStats, playerSessionID);
};
var lifetimeStats = exports.lifetimeStats = function lifetimeStats(playerSessionID) {
  return (0, _action.makeApiCallAction)('LIFETIME_STATS', _player2.default.lifetimeStats, playerSessionID);
};
var getOptOutInsByToken = exports.getOptOutInsByToken = function getOptOutInsByToken(optOutToken) {
  return (0, _action.makeApiCallAction)('GET_OPT_IN_OUTS', _player2.default.getOptOutInsByToken, optOutToken);
};
var validateCpr = exports.validateCpr = function validateCpr(cpr) {
  return (0, _action.makeApiCallAction)('VALIDATE_CPR', _player2.default.validateCpr, cpr);
};
var validateUsername = exports.validateUsername = function validateUsername(username) {
  return (0, _action.makeApiCallAction)('VALIDATE_USERNAME', _player2.default.validateUsername, username);
};
var validateEmail = exports.validateEmail = function validateEmail(email) {
  return (0, _action.makeApiCallAction)('VALIDATE_EMAIL', _player2.default.validateEmail, email);
};
var validatePhone = exports.validatePhone = function validatePhone(phone) {
  return (0, _action.makeApiCallAction)('VALIDATE_PHONE', _player2.default.validatePhone, phone);
};
var verifyExistingSePlayer = exports.verifyExistingSePlayer = function verifyExistingSePlayer(playerSessionID, verifySePlayerModel) {
  return (0, _action.makeApiCallAction)('VERIFY_EXISTING_SE_PLAYER', _player2.default.verifyExistingSePlayer, verifySePlayerModel, playerSessionID);
};
var verifyExistingSePlayerWithToken = exports.verifyExistingSePlayerWithToken = function verifyExistingSePlayerWithToken(playerSessionID, verifySePlayerModel) {
  return (0, _action.makeApiCallAction)('VERIFY_EXISTING_SE_PLAYER_WITH_TOKEN', _player2.default.verifyExistingSePlayerWithToken, verifySePlayerModel, playerSessionID);
};
var validatePersonIdv2 = exports.validatePersonIdv2 = function validatePersonIdv2(personId, jurisdiction) {
  return (0, _action.makeApiCallAction)('VALIDATE_PERSON_ID_V2', _player2.default.validatePersonIdv2, personId, jurisdiction);
};
var validateSupportNumber = exports.validateSupportNumber = function validateSupportNumber(supportNumber, jurisdiction) {
  return (0, _action.makeApiCallAction)('VALIDATE_SUPPORT_NUMBER', _player2.default.validateSupportNumber, supportNumber, jurisdiction);
};

var setEmailPhone = exports.setEmailPhone = function setEmailPhone(playerSessionID, data) {
  return (0, _action.makeApiCallAction)('SET_EMAIL_PHONE', _player2.default.setEmailPhone, playerSessionID, data.Email, data.Phone, data.Mobile);
};

var setDetailsWithoutPassword = exports.setDetailsWithoutPassword = function setDetailsWithoutPassword(playerSessionID, data) {
  return (0, _action.makeApiCallAction)('SET_DETAILS_WITHOUT_PASSWORD', _player2.default.setDetailsWithoutPassword, playerSessionID, data.Email, data.Phone, data.Mobile, data.FirstName);
};

var getActiveCurrency = exports.getActiveCurrency = function getActiveCurrency(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_ACTIVE_CURRENCY', _player2.default.getActiveCurrency, playerSessionID);
};

var setActiveCurrency = exports.setActiveCurrency = function setActiveCurrency(playerSessionID, currency) {
  return (0, _action.makeApiCallAction)('SET_ACTIVE_CURRENCY', _player2.default.setActiveCurrency, playerSessionID, currency);
};

var setExpectedAnnualActivity = exports.setExpectedAnnualActivity = function setExpectedAnnualActivity(playerSessionID, expectedAnnualActivityFrom, expectedAnnualActivityTo) {
  return (0, _action.makeApiCallAction)('SET_EXPECTED_ANNUAL_ACTIVITY', _player2.default.setExpectedAnnualActivity, playerSessionID, expectedAnnualActivityFrom, expectedAnnualActivityTo);
};

exports.default = {
  signUp: signUp,
  signUpV2: signUpV2,
  signUpWithCode: signUpWithCode,
  signUpWithToken: signUpWithToken,
  update: update,
  userInfo: userInfo,
  changePassword: changePassword,
  signIn: signIn,
  signInV2: signInV2,
  signInWithCode: signInWithCode,
  createSSOToken: createSSOToken,
  signOut: signOut,
  updatePlayerTac: updatePlayerTac,
  requestPasswordReset: requestPasswordReset,
  resetPassword: resetPassword,
  activate: activate,
  requestActivationCode: requestActivationCode,
  getTags: getTags,
  addTag: addTag,
  removeTag: removeTag,
  getOptInOuts: getOptInOuts,
  optIn: optIn,
  optOut: optOut,
  optOutChoices: optOutChoices,
  bonusOptIn: bonusOptIn,
  tournamentOptIn: tournamentOptIn,
  changeUsername: changeUsername,
  changeNickname: changeNickname,
  paymentStats: paymentStats,
  lifetimeStats: lifetimeStats,
  getOptOutInsByToken: getOptOutInsByToken,
  validateCpr: validateCpr,
  setEmailPhone: setEmailPhone,
  setDetailsWithoutPassword: setDetailsWithoutPassword,
  verifyExistingSePlayer: verifyExistingSePlayer,
  verifyExistingSePlayerWithToken: verifyExistingSePlayerWithToken,
  validatePersonIdv2: validatePersonIdv2,
  validateSupportNumber: validateSupportNumber,
  validateUsername: validateUsername,
  validateEmail: validateEmail,
  validatePhone: validatePhone,
  getDisplayPages: getDisplayPages,
  getActiveCurrency: getActiveCurrency,
  setActiveCurrency: setActiveCurrency,
  setExpectedAnnualActivity: setExpectedAnnualActivity
};